module.exports = antd.InputNumber;